export const SET_MAIN_CALENDAR = "SET_MAIN_CALENDAR";

export const SET_REG_CALENDAR = "SET_REG_CALENDAR";
